import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { addCategory, updateCategory } from 'services/category-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { required, WhiteStyledField, Title } from 'libs/form';
import { StyledButtonContainer } from './category-form.styled';

const CategoryForm = (props) => {
  const { destroy, refresh, setMessage, form, handleSubmit, close, type, id, initialValues } = props;
  const { t } = useTranslation();
  const isAdd = type === 'addForm';

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage(t('grid.Изменения сохранены'));
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const test = false;

    const out = { ...values };

    if (!isAdd) {
      out.id = id;
    }

    // test
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    const method = isAdd ? addCategory : updateCategory;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((errors) => {
        if (errors && errors.data) {
          throw new SubmissionError({
            _error: errors.data.type,
          });
        }
        if (errors && errors.message) {
          throw new SubmissionError({
            _error: errors.message,
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Новая категория') : initialValues?.name;

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <WhiteStyledField validate={required(t)} placeholder={t('form.Категория')} type="text" label={t('grid.Название')} name="name" autoFocus />
        <WhiteStyledField placeholder={t('filter.Напишите свой комментарий')} type="textarea" label={t('filter.Комментарий')} name="comment" className="multi-textarea" />
        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'categoryForm',
  destroyOnUnmount: false,
})(CategoryForm);
